module.exports = __webpack_public_path__ + "static/img/9.303b2230.png";